<template>
  <v-container fluid class="gestao-erros-page" :class="{ 'gestao-erros-page--com-abas': modoAdministrativo }">
    <v-tabs
      v-if="modoAdministrativo"
      v-model="abaGestao"
      background-color="transparent"
      class="dashboard-abas"
      color="primary"
      fixed-tabs
      height="80px"
      @change="travarTransicaoAba"
      @click.native="travarTransicaoAba"
    >
      <v-tab>
        <span>
          <div>
            <v-icon class="icon-tab mb-2">mdi-clipboard-check-outline</v-icon>
          </div>
          Gestão
        </span>
      </v-tab>
      <v-tab>
        <span>
          <div>
            <v-icon class="icon-tab mb-2">mdi-chart-box-outline</v-icon>
          </div>
          Dashboard
        </span>
      </v-tab>
    </v-tabs>

    <base-material-card color="primary" disable-doc-viewer :icon="iconeFerramenta" inline class="px-4 py-4">
      <template v-slot:after-heading>
        <div>
          <v-toolbar-title>
            <span>{{ toolbarTitle }}</span>
            <span v-if="bdgd.ordinaria">Ordinária</span>
            <span v-if="bdgd.data_registro">{{ bdgd.data_registro | formatToMonth }}</span>
            <span v-if="bdgd.versao !== null && bdgd.versao !== undefined">{{ ' v' }}{{ bdgd.versao }}</span>
          </v-toolbar-title>
        </div>
      </template>

      <v-alert class="mb-0 mt-6" color="blue" dense outlined type="info">
        Esta ferramenta é experimental e o andamento está em progresso.
      </v-alert>

      <v-row
        no-gutters
        align="start"
        class="gestao-erros-layout"
        :class="{ 'gestao-erros-layout--sem-transicao': semTransicaoAba }"
      >
        <v-col
          tag="aside"
          cols="12"
          md="4"
          lg="3"
          class="etapas-sidebar pr-md-2 pt-4"
          :class="{ 'etapas-sidebar--recolhida': !exibirEtapas }"
          style="margin-top: 30px"
        >
          <v-card class="mt-0 surface-card" outlined>
            <v-card-title class="align-center d-flex etapas-panel__header justify-space-between">
              <span>Etapas</span>
              <v-icon
                v-if="podeRecolherEtapas"
                aria-label="Ocultar etapas"
                color="grey darken-1"
                role="button"
                small
                tabindex="0"
                @click="etapasAbertas = false"
                @keyup.enter="etapasAbertas = false"
              >
                mdi-dock-left
              </v-icon>
            </v-card-title>

            <v-list class="pa-0">
              <v-row no-gutters>
                <v-col v-for="etapa in etapas" :key="etapa.etapa_nval" cols="12">
                  <v-list-item
                    class="align-center d-flex etapa-item"
                    :class="{ 'etapa-item--active': etapaEstaAtiva(etapa.etapa_nval) }"
                    @click="selecionarEtapa(etapa.etapa_nval)"
                  >
                    <v-list-item-icon class="mb-0 mr-0" style="margin-top: 3px">
                      <v-icon
                        class="align-center d-inline-flex etapa-indicador justify-center"
                        :class="`etapa-indicador--${statusEtapa(etapa)}`"
                        :style="{ color: corEtapa(etapa) }"
                        small
                      >
                        {{ iconeEtapa(etapa) }}
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content class="pa-0">
                      <v-list-item-title>
                        Etapa {{ formatarEtapa(etapa.etapa_nval) }}
                        <span v-if="siglaDaEtapa(etapa)">- {{ siglaDaEtapa(etapa) }}</span>
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action class="my-0">
                      <span class="etapa-total">{{ totalErrosEtapa(etapa) }}</span>
                    </v-list-item-action>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list>

            <div
              v-if="!etapas.length && !carregando"
              class="align-center d-flex estado-vazio estado-vazio--sidebar justify-center"
            >
              Nenhuma etapa encontrada.
            </div>
          </v-card>
        </v-col>

        <v-col
          tag="main"
          cols="12"
          md="8"
          lg="9"
          class="d-flex erros-content flex-column mt-5 pl-md-2"
          :class="{ 'erros-content--expanded': !exibirEtapas }"
        >
          <header class="align-end content-heading d-flex justify-space-between">
            <div class="align-center d-flex">
              <v-icon
                v-if="podeRecolherEtapas && !etapasAbertas"
                aria-label="Exibir etapas"
                class="mr-2"
                color="grey darken-1"
                role="button"
                small
                tabindex="0"
                @click="etapasAbertas = true"
                @keyup.enter="etapasAbertas = true"
              >
                mdi-dock-left
              </v-icon>
              <span class="content-heading__title">{{ tituloConteudo }}</span>
            </div>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" small v-on="on" @click="atualizarVisao">
                  {{ carregando ? 'mdi-loading mdi-spin' : 'mdi-refresh' }}
                </v-icon>
              </template>

              <span>{{ textoAtualizarVisao }}</span>
            </v-tooltip>
          </header>

          <template v-if="modoAdministrativo">
            <filtros-dinamicos-collapse
              v-show="!painelDashboard"
              ref="filtrosPainelGestao"
              class="mb-2 mt-0"
              :filtersProp="filtersList"
              :service="GestaoBdgdsErrosService"
              :filterSlotProp="filtrosSlotSelecionados"
              :inlineFilterCols="colsFiltroEtapa"
              serviceMethod="buscarFiltros"
              @applyFilters="aplicarFiltros"
              @resetFilters="resetarFiltros"
            >
              <template #inline-filter>
                <v-col v-if="!exibirEtapas" cols="12" md="4" class="py-0">
                  <v-select
                    clearable
                    dense
                    :items="opcoesEtapaGestao"
                    label="Etapa"
                    outlined
                    :value="etapasNoFiltroGestao"
                    @change="alterarRascunhoEtapaGestao"
                  />
                </v-col>
              </template>

              <template #after-filters="{ updateDynamicFilter }">
                <v-row>
                  <v-col cols="12" class="px-3 py-0">
                    <periodo-data
                      labelInicio="Data final de"
                      labelFim="Data final até"
                      :inicio="prazoInicio"
                      :fim="prazoFim"
                      @update:inicio="prazoInicio = $event"
                      @update:fim="prazoFim = $event"
                      @update:periodo="(periodo) => updateDynamicFilter('', { ...filtrosSlotSelecionados, ...periodo })"
                    />
                  </v-col>
                </v-row>
              </template>
            </filtros-dinamicos-collapse>

            <filtros-dinamicos-collapse
              v-show="painelDashboard"
              ref="filtrosPainelDashboard"
              class="mb-2 mt-0"
              :filtersProp="filtersList"
              :service="GestaoBdgdsErrosService"
              :filterSlotProp="filtrosSlotDashboard"
              :inlineFilterCols="colsFiltroEtapa"
              serviceMethod="buscarFiltros"
              @applyFilters="aplicarFiltrosDashboard"
              @resetFilters="resetarFiltrosDashboard"
            >
              <template #inline-filter>
                <v-col v-if="!exibirEtapas" cols="12" md="4" class="py-0">
                  <v-select
                    clearable
                    dense
                    multiple
                    :items="opcoesEtapaDashboard"
                    label="Etapa"
                    outlined
                    :value="etapasRascunhoDashboard"
                    @change="alterarRascunhoEtapaDashboard"
                  />
                </v-col>
              </template>

              <template #after-filters="{ updateDynamicFilter }">
                <v-row>
                  <v-col cols="12" class="px-3 py-0">
                    <periodo-data
                      labelInicio="Data final de"
                      labelFim="Data final até"
                      :inicio="prazoInicioDashboard"
                      :fim="prazoFimDashboard"
                      @update:inicio="prazoInicioDashboard = $event"
                      @update:fim="prazoFimDashboard = $event"
                      @update:periodo="(periodo) => updateDynamicFilter('', { ...filtrosSlotDashboard, ...periodo })"
                    />
                  </v-col>
                </v-row>
              </template>
            </filtros-dinamicos-collapse>
          </template>

          <filtros-dinamicos-collapse
            v-if="!modoAdministrativo"
            ref="filtrosDinamicosCollapse"
            class="mb-2 mt-0"
            :filtersProp="filtersList"
            :service="GestaoBdgdsErrosService"
            :filterSlotProp="filtrosSlotSelecionados"
            :inlineFilterCols="colsFiltroEtapa"
            serviceMethod="buscarFiltros"
            @applyFilters="aplicarFiltros"
            @resetFilters="resetarFiltros"
          >
            <template #inline-filter>
              <v-col v-if="!exibirEtapas" cols="12" md="4" class="py-0">
                <v-select
                  clearable
                  dense
                  multiple
                  :items="opcoesEtapaGestao"
                  label="Etapa"
                  outlined
                  :value="etapasNoFiltroGestao"
                  @change="alterarRascunhoEtapaGestao"
                />
              </v-col>
            </template>

            <template #after-filters="{ updateDynamicFilter }">
              <v-row>
                <v-col cols="12" class="px-3 py-0">
                  <periodo-data
                    labelInicio="Data final de"
                    labelFim="Data final até"
                    :inicio="prazoInicio"
                    :fim="prazoFim"
                    @update:inicio="prazoInicio = $event"
                    @update:fim="prazoFim = $event"
                    @update:periodo="(periodo) => updateDynamicFilter('', { ...filtrosSlotSelecionados, ...periodo })"
                  />
                </v-col>
              </v-row>
            </template>
          </filtros-dinamicos-collapse>

          <div v-show="!modoAdministrativo || abaGestao === 0">
            <v-row dense class="metrics-row">
              <v-col cols="12" sm="6" class="d-flex">
                <v-card class="flex-grow-1 ma-0 metric-card pa-4" outlined>
                  <div class="align-center d-flex fluxo-card__heading justify-space-between">
                    <span>PROGRESSO</span>

                    <v-icon class="fluxo-card__icon fluxo-card__icon--progress" small>mdi-trending-up</v-icon>
                  </div>

                  <strong class="d-block fluxo-card__value">{{ progressoGeral }}%</strong>

                  <v-progress-linear class="fluxo-card__progress" color="#6BCF2E" height="7" rounded :value="progressoGeral" />
                </v-card>
              </v-col>

              <v-col cols="12" sm="6" class="d-flex">
                <v-card class="flex-grow-1 ma-0 metric-card pa-4" outlined>
                  <div class="align-center d-flex fluxo-card__heading justify-space-between">
                    <span>TAREFAS CONLUÍDAS</span>

                    <v-icon class="fluxo-card__icon fluxo-card__icon--tasks" small>mdi-format-list-bulleted</v-icon>
                  </div>

                  <strong class="d-block fluxo-card__value">
                    {{ errosConcluidosGeral }}

                    <small>/{{ totalErrosGeral }}</small>
                  </strong>

                  <v-progress-linear class="fluxo-card__progress" color="primary" height="7" rounded :value="progressoGeral" />

                  <span class="d-block fluxo-card__attention">{{ itensEmAtraso }} Em atraso</span>
                </v-card>
              </v-col>

              <v-col cols="12" sm="12" md="4" class="d-flex">
                <v-card class="flex-grow-1 ma-0 metric-card pa-4" outlined>
                  <div class="align-center d-flex justify-space-between">
                    <span class="d-block fluxo-card__heading">ETAPAS COM ERROS</span>

                    <v-icon class="resumo-card__icon resumo-card__icon--stages">mdi-format-list-bulleted</v-icon>
                  </div>

                  <strong class="d-block mt-4">
                    {{ etapasComErros }}
                  </strong>
                </v-card>
              </v-col>

              <v-col cols="12" sm="12" md="4" class="d-flex">
                <v-card class="flex-grow-1 ma-0 metric-card pa-4 resumo-card--neutral" outlined>
                  <div class="align-center d-flex justify-space-between">
                    <span class="d-block fluxo-card__heading">ENTIDADES COM ERRO {{ recorteEtapas }}</span>

                    <v-icon>mdi-domain</v-icon>
                  </div>

                  <strong class="d-block mt-4">
                    {{ entidadesSelecionadas.length }}
                  </strong>
                </v-card>
              </v-col>

              <v-col cols="12" sm="12" md="4" class="d-flex">
                <v-card class="flex-grow-1 ma-0 metric-card pa-4 resumo-card--critical" outlined>
                  <div class="align-center d-flex justify-space-between">
                    <span class="d-block fluxo-card__heading">ERROS {{ recorteEtapas }}</span>

                    <v-icon>mdi-alert-circle-outline</v-icon>
                  </div>

                  <strong class="d-block mt-4">
                    {{ totalErrosEtapaSelecionada | parseNumberToIntegerBR }}
                  </strong>

                  <div class="resumo-card__distribution">
                    <div v-for="status in distribuicaoErrosEtapa" :key="status.codigo" class="resumo-card__distribution-row">
                      <span class="align-center d-flex resumo-card__distribution-label">
                        <span class="resumo-card__status-dot" :style="{ backgroundColor: status.cor }"></span>
                        {{ status.rotulo }}
                      </span>

                      <span class="resumo-card__distribution-value">
                        {{ status.quantidade | parseNumberToIntegerBR }} — {{ status.percentual }}%
                      </span>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <div v-if="carregando" class="align-center d-flex estado-vazio justify-center">
              <v-progress-circular color="primary" indeterminate size="28" />

              <span>Carregando erros...</span>
            </div>

            <div v-else-if="!etapasExibidas.length" class="align-center d-flex estado-vazio justify-center">
              Selecione uma etapa para visualizar os erros.
            </div>

            <template v-else>
              <div v-for="etapa in etapasExibidas" :key="etapa.etapa_nval" class="etapa-resumo">
                <h3 v-if="etapasExibidas.length > 1" class="etapa-resumo__titulo">
                  Etapa {{ formatarEtapa(etapa.etapa_nval) }}
                  <span v-if="siglaDaEtapa(etapa)">- {{ siglaDaEtapa(etapa) }}</span>
                </h3>

                <resumo-teste-gestao-erros
                  :bdgd="bdgd"
                  :entidades="normalizarLista(etapa.entidades)"
                  :busca="busca"
                  :erro-atualizando-id="erroAtualizandoId"
                  :modo-administrativo="modoAdministrativo"
                  :selecionados="selecionadosDaEtapa(etapa.etapa_nval)"
                  @update:selecionados="definirSelecao(etapa.etapa_nval, $event)"
                  @tarefa-executada="atualizarTarefaExecutada"
                />
              </div>
            </template>
          </div>

          <div v-if="painelDashboard" class="dashboard-painel">
            <dashboard-gestao-erros ref="dashboardGestaoErros" :filtros="filtrosDashboard" />
          </div>
        </v-col>
      </v-row>
    </base-material-card>

    <barra-encaminhamento-lote
      v-if="modoAdministrativo && errosSelecionados.length"
      :erros="errosSelecionados"
      @limpar="limparSelecao"
      @concluido="aposEncaminhamentoLote"
    />
  </v-container>
</template>

<script>
  import FiltrosDinamicosCollapse from '@/components/general/filtros/FiltrosDinamicosCollapse.vue';
  import PeriodoData from '@/components/general/inputs/PeriodoData.vue';
  import DashboardGestaoErros from '@/components/gestao-bdgds-tarefas/dashboard/DashboardGestaoErros.vue';
  import BarraEncaminhamentoLote from '@/components/gestao-bdgds-tarefas/BarraEncaminhamentoLote.vue';
  import ResumoTesteGestaoErros from '@/components/gestao-bdgds-tarefas/ResumoTesteGestaoErros.vue';
  import { coresStatusErro, iconesStatusErro, statusErroDominante } from '@/components/gestao-bdgds-tarefas/StatusErro.vue';
  import GestaoBdgdsErrosService from '@/services/GestaoBdgdsErrosService.js';

  const statusErrosEtapa = [
    { codigo: 'IDENTIFICADO', rotulo: 'Identificado', cor: coresStatusErro.IDENTIFICADO },
    { codigo: 'EM_DIAGNOSTICO', rotulo: 'Em diagnóstico', cor: coresStatusErro.EM_DIAGNOSTICO },
    { codigo: 'EM_CORRECAO', rotulo: 'Em correção', cor: coresStatusErro.EM_CORRECAO },
    { codigo: 'AGUARDANDO_VALIDACAO', rotulo: 'Aguardando validação', cor: coresStatusErro.AGUARDANDO_VALIDACAO },
    { codigo: 'ENCERRADO', rotulo: 'Encerrado', cor: coresStatusErro.ENCERRADO },
    { codigo: 'REABERTO', rotulo: 'Reaberto', cor: coresStatusErro.REABERTO },
    { codigo: 'NAO_APLICAVEL', rotulo: 'Não aplicável', cor: coresStatusErro.NAO_APLICAVEL }
  ];

  export default {
    name: 'GestaoBdgdsTarefasListar',

    components: {
      BarraEncaminhamentoLote,
      DashboardGestaoErros,
      FiltrosDinamicosCollapse,
      PeriodoData,
      ResumoTesteGestaoErros
    },

    data() {
      return {
        etapas: [],

        etapasCatalogo: [],

        dadosEtapas: [],

        cargaEtapasSeq: 0,

        resumoGestao: {
          total_erros: 0,
          erros_concluidos: 0,
          itens_em_atraso: 0
        },

        etapaSelecionadaId: null,

        etapasFiltroDashboard: [],

        etapasFiltroGestao: [],

        etapasRascunhoDashboard: [],

        etapasRascunhoGestao: [],

        rascunhoEtapaGestaoPronto: false,

        filtrosAplicadosDashboard: {},

        prazoInicioDashboard: null,

        prazoFimDashboard: null,

        etapasAbertasPorAba: {
          0: true,
          1: false
        },

        busca: '',

        filtrosSelecionados: {},

        prazoInicio: null,

        prazoFim: null,

        filtersList: {
          campo: {
            type: 'v-autocomplete',
            label: 'Campo validado',
            model: 'campo',
            items: [],
            cols: 6,
            outlined: true,
            itemText: 'text',
            itemValue: 'value'
          },
          nome_validacao: {
            type: 'v-autocomplete-async',
            label: 'Nome da validação',
            model: 'nome_validacao',
            items: [],
            cols: 6,
            outlined: true,
            serviceMethod: 'buscarNomesValidacoes',
            itemText: 'nome_validacao',
            itemValue: 'nome_validacao'
          },
          status_erro: {
            type: 'v-autocomplete',
            label: 'Status do erro',
            model: 'status_erro',
            multiple: true,
            items: [],
            cols: 3,
            outlined: true,
            itemText: 'text',
            itemValue: 'value'
          },
          tipo_tarefa: {
            type: 'v-autocomplete',
            label: 'Última tarefa definida',
            model: 'tipo_tarefa',
            multiple: true,
            items: [],
            cols: 3,
            outlined: true,
            itemText: 'text',
            itemValue: 'value'
          },
          prioridade: {
            type: 'v-autocomplete',
            label: 'Prioridade da tarefa',
            model: 'prioridade',
            multiple: true,
            items: [],
            cols: 3,
            outlined: true,
            itemText: 'text',
            itemValue: 'value'
          },
          responsavel_id: {
            type: 'v-autocomplete',
            label: 'Responsável',
            model: 'responsavel_id',
            multiple: true,
            items: [],
            cols: 3,
            outlined: true,
            itemText: 'text',
            itemValue: 'value'
          }
        },

        carregando: false,
        erroAtualizandoId: null,
        selecionadosPorEtapa: {},
        abaGestao: 0,
        semTransicaoAba: false
      };
    },

    computed: {
      bdgd() {
        return this.$store.getters.getUserSelectedCompanyBdgdVersion || {};
      },

      toolbarTitle() {
        return this.modoAdministrativo ? 'Gestão de tarefas da BDGD ' : 'Tarefas da BDGD';
      },

      GestaoBdgdsErrosService() {
        return GestaoBdgdsErrosService;
      },

      modoAcesso() {
        return (this.$route.meta || {}).modo || 'analista';
      },

      modoAdministrativo() {
        return this.modoAcesso === 'administrador';
      },

      painelDashboard() {
        return this.modoAdministrativo && this.abaGestao === 1;
      },

      errosSelecionados() {
        return Object.values(this.selecionadosPorEtapa).flat();
      },

      tituloConteudo() {
        if (this.painelDashboard) return 'GESTÃO DE ERROS';
        if (this.idsEtapa(this.etapasFiltroGestao).length > 1) return 'RESUMO DOS ERROS';
        return `RESUMO DOS ERROS :: ${this.nomeTesteEtapa || 'ERROS'}`;
      },

      textoAtualizarVisao() {
        if (this.painelDashboard) return 'Atualiza o dashboard.';
        return 'Atualiza a lista de erros e recarrega os dados da etapa selecionada.';
      },

      filtrosDashboard() {
        const filtros = { ...this.filtrosAplicadosDashboard };

        const etapas = this.idsEtapa(this.etapasFiltroDashboard);

        if (etapas.length) filtros.etapa_nval = etapas;

        return filtros;
      },

      etapasNoFiltroGestao() {
        if (!this.modoAdministrativo) return this.etapasRascunhoGestao.slice();

        const ids = this.idsEtapa(this.etapasRascunhoGestao);

        return ids.length ? ids[0] : null;
      },

      podeRecolherEtapas() {
        return this.$vuetify.breakpoint.mdAndUp;
      },

      etapasAbertas: {
        get() {
          const aba = this.modoAdministrativo ? this.abaGestao : 0;

          return this.etapasAbertasPorAba[aba];
        },
        set(aberta) {
          const aba = this.modoAdministrativo ? this.abaGestao : 0;

          this.$set(this.etapasAbertasPorAba, aba, aberta);
        }
      },

      exibirEtapas() {
        return !this.podeRecolherEtapas || this.etapasAbertas;
      },

      colsFiltroEtapa() {
        if (this.exibirEtapas) return {};

        return {
          campo: 4,
          nome_validacao: 4
        };
      },

      iconeFerramenta() {
        return this.modoAdministrativo ? 'mdi-shield-account-outline' : 'mdi-clipboard-check-outline';
      },

      filtrosSlotSelecionados() {
        return {
          prazo_inicio: this.prazoInicio,
          prazo_fim: this.prazoFim,
          modo_acesso: this.modoAcesso
        };
      },

      filtrosSlotDashboard() {
        return {
          prazo_inicio: this.prazoInicioDashboard,
          prazo_fim: this.prazoFimDashboard,
          modo_acesso: 'administrador'
        };
      },

      etapaSelecionada() {
        const ids = this.idsEtapa(this.etapasFiltroGestao);
        const id = ids.length === 1 ? ids[0] : this.etapaSelecionadaId;

        return this.etapas.find((etapa) => etapa.etapa_nval === id) || null;
      },

      opcoesEtapa() {
        return this.etapas.map((etapa) => ({
          text: this.rotuloOpcaoEtapa(etapa),
          value: etapa.etapa_nval
        }));
      },

      opcoesEtapaGestao() {
        if (!this.opcoesEtapa.length || this.modoAdministrativo) return this.opcoesEtapa;

        return [{ text: 'SELECIONAR TUDO', value: 'SELECIONAR TUDO' }, ...this.opcoesEtapa];
      },

      opcoesEtapaDashboard() {
        const origem = this.etapasCatalogo.length ? this.etapasCatalogo : this.etapas;
        const opcoes = origem.map((etapa) => ({
          text: this.rotuloOpcaoEtapa(etapa),
          value: etapa.etapa_nval
        }));

        if (!opcoes.length) return [];

        return [{ text: 'SELECIONAR TUDO', value: 'SELECIONAR TUDO' }, ...opcoes];
      },

      recorteEtapas() {
        const ids = this.idsEtapa(this.etapasFiltroGestao);

        if (ids.length > 1) return 'NAS ETAPAS SELECIONADAS';

        return `NA ${this.etapaSelecionadaRotulo}`;
      },

      etapaSelecionadaRotulo() {
        if (!this.etapaSelecionada) return 'ETAPA';

        const sigla = this.siglaDaEtapa(this.etapaSelecionada);

        return `ETAPA ${this.formatarEtapa(this.etapaSelecionada.etapa_nval)}${sigla ? ` - ${sigla}` : ''}`;
      },

      etapasExibidas() {
        const ids = this.idsEtapa(this.etapasFiltroGestao);
        const porId = new Map(this.dadosEtapas.map((etapa) => [etapa.etapa_nval, etapa]));

        return ids.map((id) => porId.get(id)).filter(Boolean);
      },

      nomeTesteEtapa() {
        for (const entidade of this.entidadesSelecionadas) {
          const erro = this.normalizarLista(entidade.erros).find((item) => item.nome_teste);

          if (erro) return erro.nome_teste;
        }

        return '';
      },

      entidadesSelecionadas() {
        return this.etapasExibidas.reduce((entidades, etapa) => entidades.concat(this.normalizarLista(etapa.entidades)), []);
      },

      errosEtapaSelecionada() {
        return this.entidadesSelecionadas.reduce((erros, entidade) => erros.concat(this.normalizarLista(entidade.erros)), []);
      },

      totalErrosEtapaSelecionada() {
        return this.errosEtapaSelecionada.length;
      },

      distribuicaoErrosEtapa() {
        const statusVisiveis = this.modoAdministrativo
          ? statusErrosEtapa
          : statusErrosEtapa.filter((status) => status.codigo !== 'IDENTIFICADO');

        return statusVisiveis.map((status) => {
          const quantidade = this.errosEtapaSelecionada.filter(
            (erro) => String(erro.status_erro || '').toUpperCase() === status.codigo
          ).length;

          return {
            ...status,
            quantidade,
            percentual: this.totalErrosEtapaSelecionada ? Math.round((quantidade / this.totalErrosEtapaSelecionada) * 100) : 0
          };
        });
      },

      etapasComErros() {
        return this.etapas.filter((etapa) => this.totalErrosEtapa(etapa) > 0).length;
      },

      totalErrosGeral() {
        return Number(this.resumoGestao.total_erros) || 0;
      },

      errosConcluidosGeral() {
        return Number(this.resumoGestao.erros_concluidos) || 0;
      },

      progressoGeral() {
        if (!this.totalErrosGeral) return 0;

        return Math.round((this.errosConcluidosGeral / this.totalErrosGeral) * 100);
      },

      itensEmAtraso() {
        return Number(this.resumoGestao.itens_em_atraso) || 0;
      }
    },

    mounted() {
      this.consultarErros();
    },

    methods: {
      async consultarErros(filtros = this.filtrosSelecionados, preservarEtapa = false) {
        this.carregando = true;
        const etapaSelecionadaId = this.etapaSelecionadaId;

        try {
          await this.atualizarOpcoesFiltros();

          const { data } = await GestaoBdgdsErrosService.listarEtapas({
            ...filtros,
            modo_acesso: this.modoAcesso
          });
          const etapas = this.normalizarLista(data.etapas)
            .slice()
            .sort((a, b) => Number(a.etapa_nval) - Number(b.etapa_nval));

          this.etapas = etapas;
          if (this.semFiltroDeCampo(filtros)) this.etapasCatalogo = etapas;
          this.resumoGestao = data.resumo || { total_erros: 0, erros_concluidos: 0, itens_em_atraso: 0 };
          this.dadosEtapas = [];

          const etapaSelecionadaExiste = etapas.some((etapa) => etapa.etapa_nval === etapaSelecionadaId);
          const etapaId = etapaSelecionadaExiste ? etapaSelecionadaId : etapas[0] && etapas[0].etapa_nval;

          if (etapaId !== undefined) {
            if (preservarEtapa) {
              this.etapasFiltroGestao = this.etapasValidas(this.etapasFiltroGestao, etapas);
            } else {
              this.etapasFiltroGestao = this.etapasValidas(this.etapasFiltroGestao, etapas, etapaId);
            }

            if (this.modoAdministrativo) {
              const idsGestao = this.idsEtapa(this.etapasFiltroGestao);
              this.etapasFiltroGestao = idsGestao.length ? [idsGestao[0]] : [];
            }

            if (preservarEtapa || !this.rascunhoEtapaGestaoPronto) {
              this.etapasRascunhoGestao = this.etapasFiltroGestao.slice();
              this.rascunhoEtapaGestaoPronto = true;
            } else {
              this.etapasRascunhoGestao = this.etapasValidas(this.etapasRascunhoGestao, etapas);
            }

            const ids = this.idsEtapa(this.etapasFiltroGestao);
            this.etapaSelecionadaId = ids[0] || (preservarEtapa ? null : etapaId);
            if (!this.painelDashboard) await this.carregarDadosEtapas(ids, filtros);
          }
        } catch (error) {
          this.$toast.error('Erro ao carregar os erros de validação.', '', { position: 'topRight' });
        } finally {
          this.carregando = false;
        }
      },

      atualizarOpcoesFiltros() {
        const filtros = this.$refs.filtrosPainelGestao || this.$refs.filtrosDinamicosCollapse;

        if (filtros && typeof filtros.atualizarFiltros === 'function') {
          return filtros.atualizarFiltros();
        }

        return Promise.resolve();
      },

      aplicarFiltros(filtros) {
        this.etapasFiltroGestao = this.etapasRascunhoGestao.slice();
        this.filtrosSelecionados = {
          ...filtros,
          prazo_inicio: this.prazoInicio,
          prazo_fim: this.prazoFim
        };
        this.consultarErros(this.filtrosSelecionados, true);
      },

      aplicarFiltrosDashboard(filtros) {
        this.etapasFiltroDashboard = this.etapasRascunhoDashboard.slice();
        this.filtrosAplicadosDashboard = {
          ...filtros,
          prazo_inicio: this.prazoInicioDashboard,
          prazo_fim: this.prazoFimDashboard
        };
      },

      resetarFiltros() {
        this.prazoInicio = null;
        this.prazoFim = null;
        this.filtrosSelecionados = {};
        this.consultarErros({});
      },

      resetarFiltrosDashboard() {
        this.prazoInicioDashboard = null;
        this.prazoFimDashboard = null;
        this.etapasFiltroDashboard = [];
        this.etapasRascunhoDashboard = [];
        this.filtrosAplicadosDashboard = {};
      },

      atualizarVisao() {
        if (this.painelDashboard) {
          if (this.$refs.dashboardGestaoErros) this.$refs.dashboardGestaoErros.carregar();
          return;
        }

        this.consultarErros();
      },

      etapaEstaAtiva(etapaId) {
        if (this.painelDashboard) return this.idsEtapa(this.etapasFiltroDashboard).includes(etapaId);

        return this.idsEtapa(this.etapasFiltroGestao).includes(etapaId);
      },

      semFiltroDeCampo(filtros) {
        return !Object.entries(filtros || {}).some(([chave, valor]) => {
          if (chave === 'modo_acesso') return false;
          if (Array.isArray(valor)) return valor.length > 0;

          return valor !== null && valor !== undefined && valor !== '';
        });
      },

      idsEtapa(selecionadas) {
        return this.normalizarLista(selecionadas).filter(
          (id) => id !== 'SELECIONAR TUDO' && id !== null && id !== undefined && id !== ''
        );
      },

      resolverSelecaoEtapas(ids, anteriores) {
        const todos = this.etapas.map((etapa) => etapa.etapa_nval);
        const proxima = this.normalizarLista(ids).filter((id) => id !== null && id !== undefined && id !== '');
        const tinhaTudo = this.normalizarLista(anteriores).includes('SELECIONAR TUDO');
        const clicouTudo = proxima.includes('SELECIONAR TUDO');

        if (clicouTudo && !tinhaTudo) return ['SELECIONAR TUDO', ...todos];

        if (!clicouTudo && tinhaTudo) return [];

        const numericas = proxima.filter((id) => id !== 'SELECIONAR TUDO');

        if (tinhaTudo && clicouTudo && numericas.length < todos.length) return numericas;

        if (!tinhaTudo && numericas.length === todos.length && todos.length > 1) {
          return ['SELECIONAR TUDO', ...todos];
        }

        return numericas;
      },

      etapaUnica(ids) {
        const id = Array.isArray(ids) ? this.idsEtapa(ids)[0] : ids;

        if (id === null || id === undefined || id === '' || id === 'SELECIONAR TUDO') return [];

        return [id];
      },

      alterarRascunhoEtapaGestao(ids) {
        this.etapasRascunhoGestao = this.modoAdministrativo
          ? this.etapaUnica(ids)
          : this.resolverSelecaoEtapas(ids, this.etapasRascunhoGestao);
        this.rascunhoEtapaGestaoPronto = true;
      },

      alterarRascunhoEtapaDashboard(ids) {
        this.etapasRascunhoDashboard = this.resolverSelecaoEtapas(ids, this.etapasRascunhoDashboard);
      },

      etapasValidas(selecionadas, etapas, etapaPadrao = null) {
        const lista = this.normalizarLista(selecionadas);

        if (lista.includes('SELECIONAR TUDO')) {
          return ['SELECIONAR TUDO', ...etapas.map((etapa) => etapa.etapa_nval)];
        }

        const validas = this.idsEtapa(lista).filter((id) => etapas.some((etapa) => etapa.etapa_nval === id));

        if (validas.length) return validas;

        return etapaPadrao === null || etapaPadrao === undefined ? [] : [etapaPadrao];
      },

      async selecionarEtapa(etapaId) {
        if (this.painelDashboard) {
          this.etapasFiltroDashboard = [etapaId];
          this.etapasRascunhoDashboard = [etapaId];
          return;
        }

        const idsAtuais = this.idsEtapa(this.etapasFiltroGestao);
        const jaExibeSoEssa =
          idsAtuais.length === 1 && idsAtuais[0] === etapaId && this.dadosEtapas.some((etapa) => etapa.etapa_nval === etapaId);

        this.etapasFiltroGestao = [etapaId];
        this.etapasRascunhoGestao = [etapaId];
        this.rascunhoEtapaGestaoPronto = true;
        this.etapaSelecionadaId = etapaId;

        if (jaExibeSoEssa) return;

        this.carregando = true;

        try {
          await this.carregarDadosEtapas([etapaId]);
        } catch (error) {
          this.$toast.error('Erro ao carregar os erros da etapa.', '', { position: 'topRight' });
        } finally {
          this.carregando = false;
        }
      },

      async carregarDadosEtapas(ids, filtros = this.filtrosSelecionados) {
        const solicitacao = this.cargaEtapasSeq + 1;
        this.cargaEtapasSeq = solicitacao;

        if (!ids.length) {
          this.dadosEtapas = [];
          return;
        }

        const respostas = await Promise.all(
          ids.map((etapaId) =>
            GestaoBdgdsErrosService.listar({
              ...filtros,
              etapa_nval: etapaId,
              modo_acesso: this.modoAcesso
            })
          )
        );

        if (solicitacao !== this.cargaEtapasSeq) return;

        this.dadosEtapas = respostas
          .map((resposta, indice) => this.normalizarLista(resposta.data.data).find((etapa) => etapa.etapa_nval === ids[indice]))
          .filter(Boolean);
      },

      selecionadosDaEtapa(etapa) {
        return this.selecionadosPorEtapa[etapa] || [];
      },

      definirSelecao(etapa, erros) {
        this.$set(this.selecionadosPorEtapa, etapa, erros);
      },

      limparSelecao() {
        this.selecionadosPorEtapa = {};
      },

      async aposEncaminhamentoLote() {
        await this.consultarErros();
      },

      async atualizarTarefaExecutada({ erroId, tarefaId } = {}) {
        if (!erroId || !tarefaId) {
          await this.consultarErros();
          return;
        }

        this.erroAtualizandoId = erroId;

        try {
          const { data } = await GestaoBdgdsErrosService.buscarTarefaNaLista(tarefaId, {
            ...this.filtrosSelecionados,
            etapa_nval: this.etapaDoErro(erroId),
            modo_acesso: this.modoAcesso
          });
          const erroAtualizado = data.data;

          if (!erroAtualizado || !this.substituirErroAtualizado(erroAtualizado)) {
            await this.consultarErros();
          }
        } catch (error) {
          if (error.response && error.response.status === 404) {
            this.removerErroDaLista(erroId);
            return;
          }

          await this.consultarErros();
        } finally {
          if (this.erroAtualizandoId === erroId) this.erroAtualizandoId = null;
        }
      },

      etapaDoErro(erroId) {
        const etapa = this.dadosEtapas.find((item) =>
          this.normalizarLista(item.entidades).some((entidade) =>
            this.normalizarLista(entidade.erros).some((erro) => erro.id === erroId)
          )
        );

        return etapa ? etapa.etapa_nval : this.etapaSelecionadaId;
      },

      substituirErroAtualizado(erroAtualizado) {
        let encontrado = false;

        this.dadosEtapas = this.dadosEtapas.map((etapa) => {
          let achouNesta = false;
          const entidades = this.normalizarLista(etapa.entidades).map((entidade) => {
            const erros = this.normalizarLista(entidade.erros);
            const indice = erros.findIndex((erro) => erro.id === erroAtualizado.id);

            if (indice < 0) return entidade;

            achouNesta = true;
            encontrado = true;

            return {
              ...entidade,
              erros: [...erros.slice(0, indice), erroAtualizado, ...erros.slice(indice + 1)]
            };
          });

          return achouNesta ? { ...etapa, entidades } : etapa;
        });

        return encontrado;
      },

      removerErroDaLista(erroId) {
        this.dadosEtapas = this.dadosEtapas.map((etapa) => ({
          ...etapa,
          entidades: this.normalizarLista(etapa.entidades)
            .map((entidade) => ({
              ...entidade,
              erros: this.normalizarLista(entidade.erros).filter((erro) => erro.id !== erroId)
            }))
            .filter((entidade) => entidade.erros.length)
        }));
      },

      normalizarLista(valor) {
        return Array.isArray(valor) ? valor : [];
      },

      siglaDaEtapa(etapa) {
        if (etapa && etapa.sigla_teste) return etapa.sigla_teste;

        const entidades = this.normalizarLista(etapa && etapa.entidades);

        for (const entidade of entidades) {
          const erro = this.normalizarLista(entidade.erros).find((item) => item.sigla_teste);

          if (erro) return erro.sigla_teste;
        }

        return '';
      },

      travarTransicaoAba() {
        this.semTransicaoAba = true;
        this.$nextTick(() => {
          this.semTransicaoAba = false;
        });
      },

      rotuloOpcaoEtapa(etapa) {
        const sigla = this.siglaDaEtapa(etapa);
        const total = this.totalErrosEtapa(etapa);

        return `Etapa ${this.formatarEtapa(etapa.etapa_nval)}${sigla ? ` - ${sigla}` : ''} (${total})`;
      },

      formatarEtapa(etapa) {
        return String(etapa).padStart(2, '0');
      },

      totalErrosEtapa(etapa) {
        if (etapa && etapa.total_erros !== undefined) return Number(etapa.total_erros) || 0;

        return this.errosDaEtapa(etapa).length;
      },

      errosDaEtapa(etapa) {
        return this.normalizarLista(etapa && etapa.entidades).reduce(
          (erros, entidade) => erros.concat(this.normalizarLista(entidade.erros)),
          []
        );
      },

      statusEtapa(etapa) {
        return this.totalErrosEtapa(etapa) ? 'erro' : 'ok';
      },

      iconeEtapa(etapa) {
        if (!this.totalErrosEtapa(etapa)) return 'mdi-check-circle';

        const status = etapa.status_dominante || statusErroDominante(this.errosDaEtapa(etapa));

        return iconesStatusErro[status] || iconesStatusErro.DESCONHECIDO;
      },

      corEtapa(etapa) {
        if (!this.totalErrosEtapa(etapa)) return this.$vuetify.theme.currentTheme.success;

        const status = etapa.status_dominante || statusErroDominante(this.errosDaEtapa(etapa));

        return coresStatusErro[status] || coresStatusErro.DESCONHECIDO;
      }
    },

    watch: {
      modoAcesso() {
        this.etapaSelecionadaId = null;
        this.dadosEtapas = [];
        this.etapasFiltroGestao = [];
        this.etapasFiltroDashboard = [];
        this.etapasRascunhoGestao = [];
        this.etapasRascunhoDashboard = [];
        this.rascunhoEtapaGestaoPronto = false;
        this.filtrosSelecionados = {};
        this.filtrosAplicadosDashboard = {};
        this.prazoInicio = null;
        this.prazoFim = null;
        this.prazoInicioDashboard = null;
        this.prazoFimDashboard = null;

        if (this.abaGestao !== 0) {
          this.abaGestao = 0;
          return;
        }

        this.consultarErros();
      },

      abaGestao(aba) {
        if (aba === 0) this.consultarErros();
      }
    }
  };
</script>

<style scoped>
  .gestao-erros-page {
    --gray-bg: #f5f5f5;
    --gray-border: #d9d9d9;
    --purple-selection: #eee3f5;
    padding: 36px 60px;
  }

  .gestao-erros-page--com-abas {
    padding-top: 0;
  }

  .gestao-erros-layout {
    row-gap: 8px;
  }

  .etapas-sidebar {
    overflow: hidden;
  }

  .etapas-sidebar .surface-card {
    transition:
      opacity 180ms ease,
      transform 260ms ease;
  }

  @media (min-width: 960px) {
    .gestao-erros-layout {
      flex-wrap: nowrap;
    }

    .etapas-sidebar,
    .erros-content {
      transition:
        flex-basis 260ms ease,
        max-width 260ms ease,
        padding 260ms ease;
    }

    .etapas-sidebar--recolhida {
      flex-basis: 0 !important;
      max-width: 0 !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .etapas-sidebar--recolhida .surface-card {
      opacity: 0;
      pointer-events: none;
      transform: translateX(-16px);
    }

    .erros-content--expanded {
      flex-basis: 100% !important;
      max-width: 100% !important;
    }
  }

  @media (min-width: 1264px) {
    .etapas-sidebar {
      flex-basis: 25%;
      max-width: 25%;
    }

    .erros-content {
      flex-basis: 75%;
      max-width: 75%;
    }
  }

  .surface-card,
  .metric-card {
    border-color: var(--gray-border) !important;
    box-shadow: 0 2px 8px rgba(32, 38, 51, 0.06) !important;
  }

  .metric-card {
    min-height: 118px;
  }

  .metrics-row {
    margin-top: 0;
    margin-bottom: 4px;
  }

  .etapa-item {
    color: #535d6c;
    cursor: pointer;
    font-size: 13px;
    gap: 5px;
    min-height: 40px;
    padding: 5px 10px;
  }

  .etapa-indicador {
    border-radius: 50%;
    height: 25px;
    width: 25px;
  }

  .etapa-indicador--erro {
    color: #ee4352;
  }

  .etapa-indicador--ok {
    color: #4fbd2e;
  }

  .etapa-label {
    flex: 1;
  }

  .etapa-total {
    color: #9aa2af;

    font-size: 11px;
  }

  .erros-content {
    gap: 8px;
    margin: 0 auto;
    padding-bottom: 24px;
    width: 100%;
  }

  .fluxo-card__heading {
    color: #7d8797;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.08em;
  }

  .fluxo-card__heading .v-icon {
    color: #8b55d2;
  }

  .fluxo-card__heading .fluxo-card__icon--progress {
    color: #95c994;
  }

  .fluxo-card__heading .fluxo-card__icon--tasks {
    color: #a8b5de;
  }

  .fluxo-card__value {
    font-size: 21px;
    font-weight: 600;
    line-height: 1.2;
    margin: 5px 0 7px;
  }

  .fluxo-card__value small {
    color: #7d8797;
    font-size: 13px;
    font-weight: 400;
  }

  .fluxo-card__attention {
    color: #ff324e;
    font-size: 10px;
    font-weight: 600;
    margin-top: 5px;
  }

  .resumo-card__icon--stages {
    color: #be9dd8;
  }

  .resumo-card--critical .v-icon {
    color: #e58d9a;
  }

  .resumo-card__distribution {
    display: flex;
    flex-direction: column;
    gap: 3px;
    margin-top: 10px;
  }

  .resumo-card__distribution-row {
    align-items: center;
    color: #626262;
    display: flex;
    font-size: 10px;
    justify-content: space-between;
    line-height: 1.2;
  }

  .resumo-card__distribution-label {
    gap: 5px;
  }

  .resumo-card__distribution-value {
    color: #555;
    font-weight: 600;
    white-space: nowrap;
  }

  .resumo-card__status-dot {
    border-radius: 50%;
    display: inline-block;
    height: 7px;
    width: 7px;
  }

  .resumo-card--neutral .v-icon {
    color: #83c7bf;
  }

  .estado-vazio {
    color: #8a93a1;
    font-size: 13px;
    gap: 10px;
    min-height: 130px;
    text-align: center;
  }

  .estado-vazio--sidebar {
    min-height: 80px;
    padding: 0 12px;
  }

  .etapas-panel__header {
    border-bottom: 1px solid #d5d5d5;
    color: #555;
    padding: 8px 12px;
  }

  .etapa-item:last-child {
    border-bottom: 0;
  }

  .etapa-item:hover,
  .etapa-item:focus-visible {
    background: var(--gray-bg);

    color: #535d6c;
  }

  .etapa-item--active,
  .etapa-item--active:hover,
  .etapa-item--active:focus-visible {
    background: var(--purple-selection);

    color: #6725bf;
  }

  .dashboard-abas {
    margin-top: 30px;
    margin-bottom: 8px;
  }

  .dashboard-abas ::v-deep .v-tabs-slider-wrapper {
    transition: none;
  }

  .gestao-erros-layout--sem-transicao .etapas-sidebar,
  .gestao-erros-layout--sem-transicao .erros-content,
  .gestao-erros-layout--sem-transicao .surface-card {
    transition: none !important;
  }

  .dashboard-painel {
    border-radius: 10px;
    margin-top: 12px;
  }

  .content-heading__title {
    color: #626262;
    font-size: 11px;
    text-transform: uppercase;
  }

  .etapa-resumo + .etapa-resumo {
    margin-top: 28px;
  }

  .etapa-resumo__titulo {
    color: #17202a;
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 12px;
  }

  @media (max-width: 960px) {
    .gestao-erros-page {
      padding: 16px;
    }
  }

  @media (max-width: 600px) {
    .gestao-erros-page {
      padding: 12px;
    }

    .metric-card {
      min-height: auto;
    }
  }
</style>
